import { render, staticRenderFns } from "./pharSupervise.vue?vue&type=template&id=f364de7e&scoped=true&"
import script from "./pharSupervise.vue?vue&type=script&lang=js&"
export * from "./pharSupervise.vue?vue&type=script&lang=js&"
import style0 from "./pharSupervise.vue?vue&type=style&index=0&id=f364de7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f364de7e",
  null
  
)

export default component.exports